import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface AlertDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children?: React.ReactNode;
}

interface AlertDialogContentProps {
  children?: React.ReactNode;
  className?: string;
}

interface AlertDialogHeaderProps {
  children?: React.ReactNode;
  className?: string;
}

interface AlertDialogFooterProps {
  children?: React.ReactNode;
  className?: string;
}

interface AlertDialogTitleProps {
  children?: React.ReactNode;
  className?: string;
}

interface AlertDialogDescriptionProps {
  children?: React.ReactNode;
  className?: string;
}

interface AlertDialogActionProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}

interface AlertDialogCancelProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}

export function AlertDialog({ open, onOpenChange, children }: AlertDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {children}
    </Dialog>
  );
}

export function AlertDialogContent({ children, className }: AlertDialogContentProps) {
  return <DialogContent className={className}>{children}</DialogContent>;
}

export function AlertDialogHeader({ children, className }: AlertDialogHeaderProps) {
  return <DialogHeader className={className}>{children}</DialogHeader>;
}

export function AlertDialogFooter({ children, className }: AlertDialogFooterProps) {
  return <DialogFooter className={className}>{children}</DialogFooter>;
}

export function AlertDialogTitle({ children, className }: AlertDialogTitleProps) {
  return <DialogTitle className={className}>{children}</DialogTitle>;
}

export function AlertDialogDescription({
  children,
  className,
}: AlertDialogDescriptionProps) {
  return <DialogDescription className={className}>{children}</DialogDescription>;
}

export function AlertDialogAction({
  children,
  onClick,
  className,
  ...props
}: AlertDialogActionProps) {
  return (
    <Button onClick={onClick} className={className} {...props}>
      {children}
    </Button>
  );
}

export function AlertDialogCancel({
  children,
  onClick,
  className,
  ...props
}: AlertDialogCancelProps) {
  return (
    <Button
      variant="outline"
      onClick={onClick}
      className={className}
      {...props}
    >
      {children}
    </Button>
  );
}

export { Dialog as AlertDialogTrigger };
